import React from 'react';
import HeaderCart from '../../components/HeaderCart';
import camera from '../../styles/lottie/camera.json';
import conditions from '../../styles/lottie/Conditions.json';
import cookies from '../../styles/lottie/cookies.json';
import phone from '../../styles/lottie/phone.json';
import Swal from 'sweetalert2';

import Lottie from 'lottie-react';
import cgu from '../../pdf/CGU.pdf';
import confidentialite from '../../pdf/politique.pdf';
const HelpScreen = () => {
  const support = () => {
    Swal.fire({
      customClass: {
        confirmButton: 'font-size: 50px',
      },
      confirmButtonColor: '#7FFFD4',
      title: 'Infos de contact',
      html: `
                <div>Email: contact@pikkopay.fr<div/>
                <div>tel: +33 6 36 94 42 81<div/>
                `,
    });
  };

  return (
    <div>
      <HeaderCart titre={"Besoin d'aide ?"} />
      <div className="flex flex-col px-10 gap-10 pt-20">
        <div
          onClick={() => support()}
          target="_blank"
          className="flex justify-between px-8 items-center border p-6 "
        >
          <p className="text-2xl flex gap-4 items-center">
            <Lottie
              animationData={phone}
              loop={false}
              // onAnimationComplete={handleFirstAnimation}
              className="w-[30px] h-[30px]"
            />
            Support
          </p>
          <span className="text-6xl pb-2">&#8250;</span>
        </div>
        <a
          href={cgu}
          target="_blank"
          className="flex justify-between px-8 items-center border p-6 "
          rel="noreferrer"
        >
          <p className="text-2xl flex gap-4 items-center">
            <Lottie
              animationData={conditions}
              loop={false}
              // onAnimationComplete={handleFirstAnimation}
              className="w-[30px] h-[30px]"
            />
            Conditions d'utilisation
          </p>
          <span className="text-6xl pb-2">&#8250;</span>
        </a>
        <a
          href={confidentialite}
          target="_blank"
          className="flex justify-between px-8 items-center border p-6 "
          rel="noreferrer"
        >
          <p className="text-2xl flex gap-4 items-center">
            <Lottie
              animationData={cookies}
              loop={false}
              // onAnimationComplete={handleFirstAnimation}
              className="w-[30px] h-[30px]"
            />
            Politique de confidentialité
          </p>
          <span className="text-6xl pb-2">&#8250;</span>
        </a>
      </div>
    </div>
  );
};

export default HelpScreen;
